import React from 'react'
import AddTodoForm from './AddTodoForm'
import { Modal } from 'react-bootstrap'
import { connect, useDispatch } from 'react-redux'
import { addTodo, addTodoModalCancel } from '../../../redux/actions/todos'

const AddTodoModal = ({ todos: { modalShow, kategoria, linkTitle, linkAddress } }) => {
    const dispatch = useDispatch()
    return <Modal show={modalShow} size='lg'>
        <Modal.Header>
            <Modal.Title>Dodaj zadanie</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <AddTodoForm
                kategoria={kategoria}
                linkAddress={linkAddress}
                linkTitle={linkTitle}
                onCancel={() => dispatch(addTodoModalCancel())}
                onSubmit={values => dispatch(addTodo(values))} />
        </Modal.Body>
    </Modal>
}

const mapStateToProps = (state, ownProps) => {
    return {
        todos: state.todos,
        ...ownProps
    }
}

export default connect(mapStateToProps)(AddTodoModal)